import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';

@Component({
  selector: 'app-endasure-pro',
  templateUrl: './endasure-pro.component.html',
  styleUrls: ['./endasure-pro.component.scss'],
  standalone: false
})
export class EndasureProComponent {
  private readonly destroy$ = new Subject<void>();
  constructor(public endasureService: EndasureService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.endasureService.upchargeData$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != null) {
        this.endurasureProForm.patchValue({
          estUpchargeForEndTractor: data.estUpchargeForEndTractor || 145.00,
          estUpchargeForEndTrailer: data.estUpchargeForEndTrailer || 130.00
        });
      }

    })

  }
  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }


  endurasureProForm = new FormGroup({
    estUpchargeForEndTractor: new FormControl(145.00, { validators: Validators.required }),
    estUpchargeForEndTrailer: new FormControl(130.00, { validators: Validators.required }),

  });
  get form() {
    return this.endurasureProForm.controls;
  }

  endaSureNxt() {
    if (this.endurasureProForm.valid) {
      this.endasureService.upchargeData$.next(this.endurasureProForm.value);
      this.endasureService.currentComponent$.next('endurasureSummary');
    }
    else {
      this.endurasureProForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }
  endaSureBack() {
    if (this.endurasureProForm.valid) {
      this.endasureService.currentComponent$.next('csaDowntime');
    }
    else {
      this.endurasureProForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }
}
